import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiCopy } = FiIcons;

const ActionButtons = ({ onEncrypt }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.5 }}
      className="w-full"
    >
      <motion.button
        whileHover={{ scale: 1.01 }}
        whileTap={{ scale: 0.99 }}
        onClick={onEncrypt}
        className="w-full flex items-center justify-center space-x-2 px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-lg font-medium rounded-xl transition-all duration-200 shadow-lg shadow-blue-600/25"
      >
        <SafeIcon icon={FiLock} className="w-5 h-5" />
        <span>Encrypt & Copy to Clipboard</span>
        <SafeIcon icon={FiCopy} className="w-5 h-5" />
      </motion.button>
    </motion.div>
  );
};

export default ActionButtons;